import { Link, Outlet } from "react-router";

import { CourseFooter } from "../course/course-footer";

// Keep the legal documents connected to the course without its account UI.
//
export default function LegalLayout() {
  return (
    <div className="flex min-h-dvh flex-col">
      <header className="border-b">
        <div className="mx-auto flex h-14 w-[calc(100%-2rem)] max-w-3xl items-center sm:w-[calc(100%-3rem)]">
          <Link
            className="font-mono text-sm font-medium underline-offset-4 hover:underline"
            to="/"
          >
            makefile.fyi
          </Link>
        </div>
      </header>
      <main className="mx-auto w-[calc(100%-2rem)] max-w-3xl flex-1 py-10 sm:w-[calc(100%-3rem)] sm:py-16">
        <Outlet />
      </main>
      <CourseFooter />
    </div>
  );
}
